<template>
    <AppHeaderDropdown right no-caret>
        <template slot="header">
        <img
            src="/img/usericon.png"
            class="img-avatar"
            alt="logo" />
        </template>\
        <template slot="dropdown">
            <b-dropdown-item @click="$emit('change-password')">
                <i class="fa fa-cog" /> Ganti Password
            </b-dropdown-item>
            <b-dropdown-item v-if="hasPasscode" @click="$emit('change-passcode')">
                <i class="fa fa-lock" /> Ganti Passcode
            </b-dropdown-item>
            <b-dropdown-item @click="$emit('logout')">
                <i class="fa fa-power-off" /> Logout
            </b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
    name: 'DefaultHeaderDropdownAccnt',
    components: {
        AppHeaderDropdown
    },
    data: () => {
        return {
            hasPasscode: false
        }
    },
    methods: {

    },
    created() {
        this.hasPasscode = localStorage.getItem("hasPasscode") === "true";
    }
}
</script>
